/** @jsx jsx */
import { jsx } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../sanityConfig";
import { getGatsbyImageData } from "gatsby-source-sanity";
import PortableTextComponent from "./portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";

const ImageTextColumnItem = ({ value, parent }) => {
  const gatsbyImageData = getGatsbyImageData(
    value.image,
    { maxWidth: 800 },
    sanityConfig
  );
  return (
    <div
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        flexDirection: ["column", "column", "column"],
        justifyContent: "center",
      }}
      className="text-image-container"
    >
      <div
        className="text-image-image"
        sx={{
          ".gatsby-image-wrapper": {
            alignItems: "flex-end",
            display: "flex",
            height: "154px",
            maxWidth:"100%",
            "> div": {
              display: "none !important",
            },
            img: {
              position: "relative",
              objectFit:"contain !important",
              // maxWidth: "232px !important",
            },
          },
        }}
      >
        <GatsbyImage image={gatsbyImageData} />
      </div>
      {value.text && (
        <div
          className="text-image-text"
          sx={{
            maxWidth: parent._type === "threeImage" ? "275px" : "210px",
            padding: "0 20px",
            color: "textGray",
            fontSize: "body",
            "h1,h2,h3,h4,h5,h6": {
              color: "primary",
            },
          }}
        >
          <PortableText value={value.text} components={PortableTextComponent} />
        </div>
      )}
    </div>
  );
};

export default ImageTextColumnItem;
